import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from './constants.service';

@Injectable({
	providedIn: 'root'
})
export class PeriodsService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	getPeriodsList(): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getPeriods`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}


	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}


}
